import { BaseCurrencyInput, Input, Select } from "@components";
import styles from "@styles/pages/cdp/filters.module.scss";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useEffect, useState } from "react";
import { If } from "shared/components/control-statements";

dayjs.extend(customParseFormat);
require("dayjs/locale/br");

const months = [
  { label: "Janeiro", value: 1 },
  { label: "Fevereiro", value: 2 },
  { label: "Março", value: 3 },
  { label: "Abril", value: 4 },
  { label: "Maio", value: 5 },
  { label: "Junho", value: 6 },
  { label: "Julho", value: 7 },
  { label: "Agosto", value: 8 },
  { label: "Setembro", value: 9 },
  { label: "Outubro", value: 10 },
  { label: "Novembro", value: 11 },
  { label: "Dezembro", value: 12 },
];

const periods = {
  day: {
    label: "Dias",
    values: "day",
  },
  month: {
    label: "Meses",
    values: "month",
  },
  year: {
    label: "Anos",
    values: "year",
  },
};

export default function DateForm({ data, input_configs, onChange }) {
  const [values, setValues] = useState(data?.values);
  const [valueType, setValueType] = useState(data?.value_type || "day");

  useEffect(() => {
    onChange({ ...data, values, value_type: valueType });
  }, [values, valueType]);

  useEffect(() => {
    if (data.operand === "in_last" || data.operand === "in_next") setValueType("day");
    if (data.operand === "bt") setValueType("date");
    if (data.operand === "month") setValues(values || months[0].value);
  }, [data.operand]);

  return (
    <>
      <If cond={data?.operand === "in_last" || data?.operand === "in_next"}>
        <div className="d-flex align-center">
          <BaseCurrencyInput
            placeholder="Inserir valor"
            className="pt-0 w-100 mb-0"
            precision={0}
            prefix=""
            type="tel"
            value={values}
            onChange={(v) => setValues(v)}
            autoFocus
          />
          <Select
            title="Selecione o tempo..."
            className="w-100 mb-0 ml-15"
            options={Object.values(periods)}
            onChange={(e) => {
              setValueType(
                Object.values(periods).find(
                  (period) => period.label === e.target.value
                )?.values
              );
            }}
          />
        </div>
      </If>

      <If cond={data?.operand === "month"}>
        <Select
          title="Selecione o tempo..."
          className="w-100 mb-0"
          options={months}
          onChange={(e) => setValues(e.target.value)}
        />
      </If>

      <If cond={data?.operand === "bt"}>
        <div className="d-flex align-center">
          <Input
            placeholder="dd/mm/aaaa"
            mask="99/99/9999"
            type="tel"
            value={values?.[0] || null}
            onChange={(e) =>
              setValues((prevValues) => [e.target.value, prevValues?.[1]])
            }
            autoFocus
            className="mb-0"
            {...input_configs}
          />
          <span className={styles.to}>Até</span>
          <Input
            placeholder="dd/mm/aaaa"
            mask="99/99/9999"
            type="tel"
            value={values?.[1] || null}
            onChange={(e) =>
              setValues((prevValues) => [prevValues?.[0], e.target.value])
            }
            className="mb-0"
            {...input_configs}
          />
        </div>
      </If>
    </>
  );
}
